import { Directive, Input, ElementRef, HostListener } from '@angular/core';
import { AppAbstractDirective } from './appAbstractDirective';

@Directive({
  selector: '[appTableInputSearch]'
})
export class AppTableInputSearchDirective extends AppAbstractDirective  {

  // ********************** Propiedades de la directiva ********************

  @Input() tableId: string;
  inputElement: any;

  // ********************** Constructor ************************************

  constructor(private element: ElementRef) {
    super();
  }

  // ********************** Eventos ****************************************

  @HostListener('keyup', ['$event']) onkeyup(event: KeyboardEvent): void {
    const table = $('#' + this.tableId).DataTable();
    if (event.code === 'ArrowDown') {
      let cell: any = {};
      cell = table.cell(':eq(0)', { page: 'current' });
      cell.focus();
      cell.node().focus();
    } else if (event.code === 'Enter') {
      const recordsDisplay = table.page.info().recordsDisplay;
      if (recordsDisplay === 1) {
        let cell: any = {};
        cell = table.cell(':eq(0)', { page: 'current' });
        $(cell.node()).trigger('click');
      }
    } else {
      this.inputElement = this.element.nativeElement;
      if (this.inputElement) {
        const searchValue = this.inputElement.value;
        if (searchValue || searchValue === '') {
          table.search(searchValue);
          table.draw();
        }
      }
    }
  }

  @HostListener('focus', ['$event.target']) focus(): void {
    (this.element.nativeElement as HTMLInputElement).select();
  }

}
